import type React from 'react';
import { CardHeader, CardTitle } from '../tailgrids/core/card.js';
import { cn } from '../../utils/cn.js';

interface ToolbarProps {
  /** The card title on the left ("Last transactions"); omit when the page title already names the list. */
  title?: string;
  /** The list search box. */
  search?: React.ReactNode;
  /** Quick filters (`FilterPills`), on the left next to the title. */
  pills?: React.ReactNode;
  /** Scoped selects and outline icon buttons (filter, export), after the search. */
  right?: React.ReactNode;
  className?: string;
}

/**
 * The header row of a list card, no border. Template example: NextAdmin
 * `(dashboard)/(home)/_component/last-transactions-table` `CardHeader className="mb-6"`: `CardTitle` on the left,
 * search `InputGroup`, outline icon buttons and selects on the right (they wrap under on phones).
 */
export function Toolbar({ title, search, pills, right, className }: ToolbarProps) {
  const hasLeft = Boolean(title || pills);
  const hasRight = Boolean(search || right);
  return (
    <CardHeader className={cn('mb-6', className)}>
      {hasLeft && (
        <div className="flex min-w-0 flex-wrap items-center gap-3">
          {title && <CardTitle>{title}</CardTitle>}
          {pills}
        </div>
      )}
      {hasRight && (
        <div className={cn('flex min-w-0 flex-wrap items-center gap-1.5', !hasLeft && 'flex-1')}>
          {search}
          {right}
        </div>
      )}
    </CardHeader>
  );
}
